import React, { Component } from 'react'
import { Form, DatePicker } from 'antd';

export class SignDate extends Component {
  render() {
    const { unlimitEdit } = this.props;
    return <>
      <div className="title-contract title-special">2. Ngày ký hợp đồng*</div>
      <Form.Item
        id="item1"
        name="sign_date"
        wrapperCol={24}
        rules={[
          {
            required: true,
            message: `Vui lòng chọn ngày ký hợp đồng!`,
          }
        ]}
      >
        <DatePicker
          // inputReadOnly
          dropdownClassName="date-picker-dropdown-top"
          disabled={!unlimitEdit}
          getPopupContainer={node => {
            if (node) {
              return node.parentNode;
            }
            return document.body;
          }} format='DD/MM/YYYY' className="dropdown-full" />
      </Form.Item>
    </>
  }
}
